import type { FindFn } from "@shared/models/analytics/base"
import { createBlankEvent } from "@shared/models/analytics/base"
import type { GroupUnlock } from "@shared/models/analytics/group"
import type { Group } from "@shared/models/group"
import type { PreparedAction } from "@shared/actions/action-doc-builder"
import { partial } from "lodash-es"
import type { Narrative } from "@shared/actions/create-narrative"

interface Payload {
  form: "teacher" | "admin" | "district-admin"
  group?: Group
  // From the group or the school name input.
  groupTitle: string
  adminEmail: string
}

export default function groupUnlockSubmitRequestAction(payload: Payload): PreparedAction {
  return {
    name: "GROUP_UNLOCK_SUBMIT_REQUEST",
    payload: payload,
    patches: null,
    undoPatches: null,
    narrative: partial(narrative, payload),
  }
}

function narrative(payload: Payload, _findFn: FindFn, _userId: string): Narrative {
  const groupUsedAs =
    payload.group?.attributes.usedAs ??
    (payload.form === "district-admin" ? "school-network" : "school")
  const groupTitle = payload.groupTitle

  let newEvent: GroupUnlock = {
    ...createBlankEvent(),
    root_id: null,
    root_type: "app",
    date_plan_scheduled_for: null,

    primary_verb: "unlock",
    primary_possessive: "owns",

    primary_object_type: "group",
    primary_object_id: payload.group?.id || null,
    primary_object_specifier: groupUsedAs === "school-network" ? "school_network" : "school",
    primary_object_id_and_ancestor_ids: payload.group ? [payload.group.id] : [],

    adverbial_verb: "navigating",

    adverbial_object_type: "screen",
    adverbial_object_id: "submit_request",
    adverbial_object_specifier: payload.form,
  }

  return {
    title: "User submitted group unlock request",
    titleForAnalytics: "Group - Unlock - Submit Request",
    description: `Submitted unlock request for ${groupUsedAs} ${groupTitle}`,
    context: {
      groupId: payload.group?.id,
      groupUsedAs,
      groupTitle,
      form: payload.form,
      adminEmail: payload.adminEmail,
    },
    newAnalyticsEvents: [newEvent],
  }
}
